export default __webpack_public_path__ + "static/media/image.geekxo-pvt-ltd.d2e14503.png";